import { Navigate } from 'react-router-dom';
import Session from '../session';
import AppProvider from '../context/app-context';
import UserService from '../services/UserService';

function PrivateRoute({ children }) {
    const isLogin = UserService.isLoggedIn();
    return isLogin ? (
        <AppProvider>
            <Session>{children}</Session>
        </AppProvider>
    ) : (
        <Navigate to="/login" />
    );
}

export default PrivateRoute;
